export function getCsrfToken(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)__tk_csrf=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}
